export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const popularTabs = {
  popularetab: {
    slide: {
      Aviator: {
        redirectUrl: "/casino/spribe-aviator",
        code: "",
        casino: "spribe",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/aviator.webp",
        alt: "Aviator",
        name: "Aviator",
        providerName: "Spribe",
      },
      Cricket: {
        redirectUrl: "/sportsbook/Cricket",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/cricket.webp",
        alt: "",
        name: "Cricket",
        providerName: "Evolution",
      },
      HorseRacing: {
        redirectUrl: "/sportsbook/Horse Racing",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/horseracing.webp",
        alt: "",
        name: "Horse Racing",
        providerName: "Evolution",
      },
      FrenchRoulette: {
        redirectUrl: "/casino/vivo-french-roulette",
        code: "",
        casino: "vivo",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/Vivo/FrenchRoulette.jpg",
        alt: "french roulette",
        name: "French Roulette",
        providerName: "Vivo",
      },
      GalaxyRoulette: {
        redirectUrl: "/casino/vivo-galaxy-roulette",
        code: "",
        casino: "vivo",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/Vivo/GalaxyRoulette.jpg",
        alt: "galaxy roulette",
        name: "Galaxy Roulette",
        providerName: "Vivo",
      },
      MacauBaccarat: {
        redirectUrl: "/casino/vivo-macau-baccarat",
        code: "",
        casino: "vivo",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/Vivo/MacauBaccarat.jpg",
        alt: "macau baccarat",
        name: "Macau Baccarat",
        providerName: "Vivo",
      },
      SpeedRoulettePplr: {
        redirectUrl: "/casino/ezugi/SpeedRoulette",
        code: "1000104",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/speed-roulette-evolution.jpg",
        alt: "",
        name: "Speed Roulette",
        providerName: "Evolution",
      },
      LightningRoulettePplr: {
        redirectUrl: "/casino/ezugi/LightningRoulette",
        code: "1000092",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Lightiningroulette.jpg",
        alt: "",
        name: "Lightning Roulette",
        providerName: "Evolution",
      },
      CasinoMarinaRoulettePplr: {
        redirectUrl: "/casino/ezugi/CasinoMarinaRoulette",
        code: "321000",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/roulette/Casino-Marina-Roulette.jpg",
        alt: "",
        name: "Casino Marina Roulette",
        providerName: "Ezugi",
      },
      BaccaratPplr: {
        redirectUrl: "/casino/ezugi/Baccarat",
        code: "100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/baccarat08.jpg",
        alt: "",
        name: "Baccarart",
        providerName: "Ezugi",
      },

      LightBaccaratPplr: {
        redirectUrl: "/casino/ezugi/LightBaccarat",
        code: "1000149",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/baccarat/lightning-baccarat.jpg",
        alt: "",
        name: "Lightning Baccarat",
        providerName: "Evolution",
      },
      BlackjackProPplr: {
        redirectUrl: "/casino/ezugi/BlackjackPro",
        code: "224",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/blackjack/vip-surrender-blackjack.jpg",
        alt: "",
        name: "VIP Surrender Blackjack",
        providerName: "Ezugi",
      },

      BetonTeenPattiPplr: {
        redirectUrl: "/casino/ezugi/BetonTeenPatti",
        code: "227101",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/Betonteenpatti.jpg",
        alt: "",
        name: "Bet on Teen Patti",
        providerName: "Ezugi",
      },
      TeenPatti3cardPplr: {
        redirectUrl: "/casino/ezugi/TeenPatti3card",
        code: "227100",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/Teenpatti3card.jpg",
        alt: "",
        name: " Teen Patti 3 Card",
        providerName: "Ezugi",
      },
      UltimatetexasholdemPplr: {
        redirectUrl: "/casino/ezugi/Ultimatetexasholdem",
        code: "1000151",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/poker/ultimatetaxasholden.jpg",
        alt: "",
        name: "Ultimate Texas Holdem",
        providerName: "Evolution",
      },
      CrazyTimePplr: {
        redirectUrl: "/casino/ezugi/CrazyTime",
        code: "1000148",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/CrazyTime.jpg",
        alt: "",
        name: "Crazy Time",
        providerName: "Evolution",
      },
      DreamCatcherPplr: {
        redirectUrl: "/casino/ezugi/DreamCatcher",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/tvshows/DreamCatcher.jpg",
        alt: "",
        name: "Dream Catcher",
        providerName: "Evolution",
      },
      TeenPatti2020: {
        redirectUrl: "/casino/sn-teen-patti-2020",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/teenpatti2020.webp",
        alt: "",
        name: "Teen Patti 2020",
        providerName: "Supernowa",
      },
      OneDayTeenPatti: {
        redirectUrl: "/casino/ezg-one-day-teen-patti",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/onedayteenpatti.webp",
        alt: "",
        name: "One Day Teen Patti",
        providerName: "Ezugi",
      },
      NoCommissionBaccaratA: {
        redirectUrl: "/casino/ezg-no-commission-baccarat-a",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/nocommissionbaccararA.png",
        alt: "",
        name: "No Commission Baccarat A",
        providerName: "Ezugi",
      },
      NoCommissionBaccaratB: {
        redirectUrl: "/casino/ezg-no-commission-baccarat-b",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/nocommissionbaccararB.png",
        alt: "",
        name: "No Commission Baccarat B",
        providerName: "Ezugi",
      },

      NamasteRoulette: {
        redirectUrl: "/casino/ezg-namaste-roulette",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/namasterroulette.png",
        alt: "",
        name: "Namaste Roulette",
        providerName: "Ezugi",
      },
      MuflisTeenPatti: {
        redirectUrl: "/casino/sn-muflis-teenpatti",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/muflisteenpatti.webp",
        alt: "",
        name: "Muflis Teen Patti",
        providerName: "Supernowa",
      },
      Lucky7: {
        redirectUrl: "/casino/ezg-lucky-7",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/lucky7.png",
        alt: "",
        name: "Lucky 7",
        providerName: "Ezugi",
      },
      ItalianRoulette: {
        redirectUrl: "/casino/ezg-italian-roulette",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/italianroulette.png",
        alt: "",
        name: "Italian Roulette",
        providerName: "Ezugi",
      },
      GoldBlackjack1: {
        redirectUrl: "/casino/ezg-gold-blackjack-1",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/goldblackjack1.png",
        alt: "",
        name: "Gold Blackjack 1",
        providerName: "Ezugi",
      },
      GoldBlackjack3: {
        redirectUrl: "/casino/ezg-gold-blackjack-3",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/goldblackjack3.png",
        alt: "",
        name: "Gold Blackjack 3",
        providerName: "Ezugi",
      },
      AutoRoulette: {
        redirectUrl: "/casino/ezg-football-auto-roulette",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/autoroulette.png",
        alt: "",
        name: "Auto Roulette",
        providerName: "Ezugi",
      },
      BlackjackdaSorte: {
        redirectUrl: "/casino/ezg-blackjack-da-sorte",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/Blackjackdasorte.png",
        alt: "",
        name: "Blackjack da Sorte",
        providerName: "Ezugi",
      },
      CricketAutoRoulette: {
        redirectUrl: "/casino/ezg-cricket-auto-roulette",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/cricketautoroulette.png",
        alt: "",
        name: "Cricket Auto Roulette",
        providerName: "Ezugi",
      },
      DragonTiger: {
        redirectUrl: "/casino/ezg-dragon-tiger",
        code: "1000077",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/Casino"),
        imgUrl: "./images/home/dragontiger.webp",
        alt: "",
        name: "Dragon Tiger",
        providerName: "Ezugi",
      },
       TeenPattiVivo: {
        name: "Teen Patti",
        redirectUrl: "/casino/vivo-teen-patti",
        code: "mines",
        casino: "spribe",
        provider: "vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/TeenPattiVivo.webp", alt: "",
      },
      ndarbaharVivo: {
        name: "Andar Bahar",
        redirectUrl: "/casino/vivo-andar-bahar",
        code: "goal",
        casino: "spribe",
        provider: "vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/AndarBaharVivo.webp", alt: "",
      },
      lasvegasjackpotroulette: {
        name: "Las Vegas Jackpot Roulette",
        redirectUrl: "/casino/vivo-las-vegas-jackpot-roulette",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/lasvegasjackpotrou.jpg", alt: "",
      },
      lasvegasroulette: {
        name: "Las Vegas Roulette",
        redirectUrl: "/casino/vivo-las-vegas-roulette",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/vivo-las-vegas-roulette.webp", alt: "",
      },
      PortomasoRoulette: {
        name: "Portomaso Roulette",
        redirectUrl: "/casino/vivo-portomaso-roulette",
        code: "aviator",
        casino: "spribe",
        provider: "vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/vivo-portomaso-roulette.webp", alt: "" ,
      },
      ImperialDragonTiger: {
        name: "Imperial Dragon Tiger",
        redirectUrl: "/casino/aggapvivogaming-imperial-dragon-tiger",
        code: "plinko",
        casino: "spribe",
        provider: "viov",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/imperialdragontiger.jpg", alt: "" ,
      },
      BlazeRoulette: {
        name: "Blaze Roulette",
        redirectUrl: "/casino/vivo-oracle-blaze-roulette",
        code: "mini-roulette",
        casino: "spribe",
        provider: "Vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/vivo-oracle-blaze-roulette.webp", alt: "" ,
      },
      OracleTwisterRoulette: {
        name: "Oracle Twister Roulette",
        redirectUrl: "/casino/aggapvivogaming-oracle-twister-roulette",
        code: "hi-lo",
        casino: "spribe",
        provider: "Vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/OracleTwisterRoulette.jpg", alt: "" ,
      },
      AmericanAutoRoulette: {
        name: "American Auto Roulette",
        redirectUrl: "/casino/aggapvivogaming-american-auto-roulette",
        code: "hi-lo",
        casino: "spribe",
        provider: "Vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/AmericanAutoRoulette.jpg", alt: "" ,
      },
      Oracle360Roulette: {
        name: "Oracle 360 Roulette",
        redirectUrl: "/casino/vivo-oracle-360-roulette",
        code: "hi-lo",
        casino: "spribe",
        provider: "Vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/Oracle360Roulette.jpg", alt: "" ,
      },
    },
  },



  vivo: {
    slide: {
      TeenPattiVivo: {
        name: "Teen Patti",
        redirectUrl: "/casino/vivo-teen-patti",
        code: "mines",
        casino: "spribe",
        provider: "vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/TeenPattiVivo.webp", alt: "",
      },
      ndarbaharVivo: {
        name: "Andar Bahar",
        redirectUrl: "/casino/vivo-andar-bahar",
        code: "goal",
        casino: "spribe",
        provider: "vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/AndarBaharVivo.webp", alt: "",
      },
      lasvegasjackpotroulette: {
        name: "Las Vegas Jackpot Roulette",
        redirectUrl: "/casino/vivo-las-vegas-jackpot-roulette",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/lasvegasjackpotrou.jpg", alt: "",
      },
      lasvegasroulette: {
        name: "Las Vegas Roulette",
        redirectUrl: "/casino/vivo-las-vegas-roulette",
        code: "dice",
        casino: "spribe",
        provider: "dice",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/vivo-las-vegas-roulette.webp", alt: "",
      },
      PortomasoRoulette: {
        name: "Portomaso Roulette",
        redirectUrl: "/casino/vivo-portomaso-roulette",
        code: "aviator",
        casino: "spribe",
        provider: "vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/vivo-portomaso-roulette.webp", alt: "" ,
      },
      ImperialDragonTiger: {
        name: "Imperial Dragon Tiger",
        redirectUrl: "/casino/aggapvivogaming-imperial-dragon-tiger",
        code: "plinko",
        casino: "spribe",
        provider: "viov",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/imperialdragontiger.jpg", alt: "" ,
      },
      BlazeRoulette: {
        name: "Blaze Roulette",
        redirectUrl: "/casino/vivo-oracle-blaze-roulette",
        code: "mini-roulette",
        casino: "spribe",
        provider: "Vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/vivo-oracle-blaze-roulette.webp", alt: "" ,
      },
      OracleTwisterRoulette: {
        name: "Oracle Twister Roulette",
        redirectUrl: "/casino/aggapvivogaming-oracle-twister-roulette",
        code: "hi-lo",
        casino: "spribe",
        provider: "Vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/OracleTwisterRoulette.jpg", alt: "" ,
      },
      AmericanAutoRoulette: {
        name: "American Auto Roulette",
        redirectUrl: "/casino/aggapvivogaming-american-auto-roulette",
        code: "hi-lo",
        casino: "spribe",
        provider: "Vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/AmericanAutoRoulette.jpg", alt: "" ,
      },
      Oracle360Roulette: {
        name: "Oracle 360 Roulette",
        redirectUrl: "/casino/vivo-oracle-360-roulette",
        code: "hi-lo",
        casino: "spribe",
        provider: "Vivo",
        homeUrl: "",
        providerName: "Vivo",
        imgUrl: "./images/Vivo/Oracle360Roulette.jpg", alt: "" ,
      },
    }
   
  },




};
